import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import Lenis from "lenis";
import "@/App.css";
import "@/index.css";
import { LanguageProvider } from "./i18n/LanguageContext";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import EditorialMarquee from "./components/EditorialMarquee";
import ServicesBento from "./components/ServicesBento";
import Craftsmanship from "./components/Craftsmanship";
import ReviewsMarquee from "./components/ReviewsMarquee";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import FloatingContact from "./components/FloatingContact";
import { LogoMark } from "./components/Logo";
import { EASE } from "./components/Reveal";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { err: false };
  }
  static getDerivedStateFromError() {
    return { err: true };
  }
  render() {
    if (this.state.err) {
      return (
        <div className="min-h-screen bg-[#0D0F12] flex items-center justify-center p-10 text-center">
          <p className="text-[#F4F1EA] font-display text-xl">BoomGradnja — doslo je do greske pri ucitavanju.</p>
        </div>
      );
    }
    return this.props.children;
  }
}

const Preloader = () => (
  <motion.div
    className="fixed inset-0 z-[100] bg-[#0D0F12] flex flex-col items-center justify-center gap-5"
    exit={{ y: "-100%", transition: { duration: 0.65, ease: [0.76, 0, 0.24, 1] } }}
  >
    <motion.div initial={{ opacity: 0, scale: 0.8 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.5, ease: EASE }}>
      <LogoMark className="w-14 h-14 text-[#F4F1EA]" />
    </motion.div>
    <div className="flex overflow-hidden">
      {"BOOMGRADNJA".split("").map((ch, i) => (
        <motion.span
          key={i}
          initial={{ y: "110%" }}
          animate={{ y: 0 }}
          transition={{ duration: 0.5, delay: 0.15 + i * 0.045, ease: EASE }}
          className="font-display font-extrabold text-2xl tracking-widest text-[#F4F1EA] inline-block"
        >
          {ch}
        </motion.span>
      ))}
    </div>
    <motion.div initial={{ scaleX: 0 }} animate={{ scaleX: 1 }} transition={{ duration: 0.9, delay: 0.3, ease: EASE }} className="h-[2px] w-40 bg-[#D96B27] origin-left" />
  </motion.div>
);

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    const t = setTimeout(() => setLoading(false), 1300);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
      clearTimeout(t);
    };
  }, []);

  return (
    <LanguageProvider>
      <ErrorBoundary>
        <AnimatePresence>{loading && <Preloader />}</AnimatePresence>
        <div className="bg-[#0D0F12] min-h-screen overflow-x-clip">
          <Navbar />
          <main>
            <Hero />
            <EditorialMarquee />
            <ServicesBento />
            <Craftsmanship />
            <ReviewsMarquee />
            <ContactSection />
          </main>
          <Footer />
          <FloatingContact />
        </div>
      </ErrorBoundary>
    </LanguageProvider>
  );
}

export default App;
